import {AutogenLayoutMainBrokerageTrackingControlPanel} from "./autogen/AutogenLayoutMainBrokerageTrackingControlPanel";
import {ChangeEvent, DataDisplayEvent} from "@mcleod/components";
import {Api, StringUtil} from "@mcleod/core";
import {CommonDialogs} from "@mcleod/common";

export class MainBrokerageTrackingControlPanel extends AutogenLayoutMainBrokerageTrackingControlPanel{

    switchAutomateTrackingInitiationOnChange(event: ChangeEvent): void{
        this.textboxHoursPrior.visible = event.newValue === true;
        this.textboxTrackingBrokerageStatus.visible = event.newValue === true;
        this.textboxTrackingRateConf.visible = event.newValue === true;
    }

    async switchAutomateIsDefaultOnChange(event: ChangeEvent): Promise<void> {
        this.switchRequireTracking.visible = event.newValue === true;

        if (!event.userInitiatedChange || event.newValue !== true) {
            return;
        }
       const response = await Api.search("lme/powerbroker/get-update-default-vendor", {
            "vendor": this.mainDataSource.activeRow.get("vendor"),
        });

        if (response.data[0]?.default_vendor_list === undefined) {
            return;
        }
        const userConfirmed = await this.confirmChangeDefaultVendor(response.data[0].default_vendor_list);
        if (userConfirmed) {
            await Api.update("lme/powerbroker/get-update-default-vendor", {
                "vendor": this.mainDataSource.activeRow.get("vendor"),
            });
        } else {
            this.switchIsDefault.checked = false;
        }
    }


    private async confirmChangeDefaultVendor(defaultVendorList: any): Promise<boolean> {
        return await CommonDialogs.showYesNo(
            `Only one vendor can be the default, selecting "Yes" will disable the previous default vendor: ${this.getDefaultVendorList(defaultVendorList)}`,
            "Change Default Vendor"
        );
    }

    private getDefaultVendorList(default_vendor_list: any): string {
        let result = "\n\n";
        for (let i = 0; i < default_vendor_list.length; i++) {
            result += default_vendor_list[i].vendor + "\n";
        }
        return result;
    }
}
